import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { useQuery } from 'react-query';
import { motion } from 'framer-motion';
import { FiArrowLeft, FiFolder } from 'react-icons/fi';
import * as folderService from '../../services/folders';
import * as documentService from '../../services/documents';
import '../../styles/main.scss';

const FolderDetail = () => {
  const { id } = useParams();

  const { data: folderResponse, isLoading: isFolderLoading, isError: isFolderError } = useQuery(
    ['folder', id],
    () => folderService.getFolder(id),
    {
      enabled: !!id,
    }
  );

  const { data: documentsResponse, isLoading: isDocumentsLoading } = useQuery(
    ['folder-documents', id],
    () =>
      documentService.getDocuments({
        folderId: id,
        limit: 50,
      }),
    {
      enabled: !!id,
    }
  );

  const folder = folderResponse?.folder || folderResponse?.data?.folder || folderResponse;
  const documents = documentsResponse?.data || documentsResponse?.documents || [];

  if (isFolderLoading) {
    return (
      <div className="dashboard-page folder-detail-page">
        <div className="page-header">
          <div className="skeleton skeleton-text" style={{ width: '240px', height: '32px' }} />
        </div>
      </div>
    );
  }

  if (isFolderError || !folder) {
    return (
      <div className="dashboard-page folder-detail-page">
        <div className="page-header">
          <div>
            <h1>Folder not found</h1>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="dashboard-page folder-detail-page">
      <div className="page-header">
        <div>
          <Link to="/folders" className="btn btn-outline">
            <FiArrowLeft />
            <span>Back to folders</span>
          </Link>
          <h1>{folder.name}</h1>
          <p>{folder.description || 'No description provided for this folder.'}</p>
        </div>
      </div>

      <div className="page-content">
        <div className="document-detail-layout">
          <motion.div
            className="section-card"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <div className="section-header">
              <h2>Documents in this folder</h2>
            </div>
            {isDocumentsLoading ? (
              <div className="loading-placeholder">
                {[...Array(3)].map((_, index) => (
                  <div key={index} className="skeleton skeleton-text" />
                ))}
              </div>
            ) : documents.length === 0 ? (
              <div className="empty-state">
                <FiFolder size={32} />
                <p>No documents in this folder yet.</p>
              </div>
            ) : (
              <div className="documents-grid">
                {documents.map((doc) => (
                  <motion.div
                    key={doc._id}
                    className="document-card"
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                  >
                    <Link to={`/documents/${doc._id}`}>
                      <div className="document-header">
                        <div className="document-icon">
                          <FiFolder />
                        </div>
                        <div className={`status-badge status-${doc.status}`}>
                          {doc.status}
                        </div>
                      </div>
                      <div className="document-body">
                        <h3>{doc.name}</h3>
                        <p className="document-number">{doc.documentNumber}</p>
                      </div>
                    </Link>
                  </motion.div>
                ))}
              </div>
            )}
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default FolderDetail;
